import bgImg from '@/assets/img/curved-images/curved9.jpg';
import { SessionLayout } from '@/components/layout/SessionLayout';
import { useCreatePasswordReset } from '@/hooks/api/0070_create_user_password_reset';
import { SubmitHandler, useForm } from 'react-hook-form';
import { useLoading } from '@/providers/LoadingProvider';
import { useEffect } from 'react';
import { toastSuccess } from '@/lib/toast';
import { Link, useNavigate } from 'react-router-dom';
import { ApiErrorMessages } from '@/components/element/ApiErrorMessages';

type FormInputs = {
  email: string;
};

export const PasswordResetNew = () => {
  const { mutate, isPending, data, error } = useCreatePasswordReset();
  const { setShowLoading } = useLoading();
  const navigate = useNavigate();

  const {
    register,
    handleSubmit,
    formState: { errors },
  } = useForm<FormInputs>({
    mode: 'onBlur',
    criteriaMode: 'all',
  });

  useEffect(() => setShowLoading(isPending), [isPending]);

  useEffect(() => {
    if (data) {
      toastSuccess('登録されているメールアドレスにメールを送信しました。');
      navigate(`/password_reset/code`, { state: { token: data.user_password_reset_token } });
    }
  }, [data]);

  const onSubmit: SubmitHandler<FormInputs> = (data) => {
    setShowLoading(true);
    mutate(data);
  };

  return (
    <SessionLayout>
      <main className="main-content mt-0">
        <div className="page-header min-vh-100" style={{ backgroundImage: `url(${bgImg})` }}>
          <span className="mask bg-gradient-dark opacity-6"></span>
          <div className="container">
            <div className="row">
              <div className="col-lg-5 col-md-7 mx-auto">
                <div className="card z-index-0 mt-sm-12 mt-9 mb-4">
                  <div className="card-header text-center pt-4 pb-1">
                    <h4 className="font-weight-bolder mb-1">Reset Password</h4>
                    <p className="mb-0">入力したアドレスにパスワード再設定のメールを送信します</p>
                  </div>
                  <div className="card-body">
                    <form role="form" onSubmit={handleSubmit(onSubmit)}>
                      <ApiErrorMessages error={error} />

                      <div className="mb-3">
                        <input
                          type="email"
                          maxLength={50}
                          className={`form-control ${errors.email && 'is-invalid'}`}
                          placeholder={'メールアドレス'}
                          aria-label="Email"
                          {...register('email', {
                            required: '入力して下さい。',
                          })}
                        />
                      </div>
                      <div className="text-center mb-3">
                        <button className="btn bg-gradient-dark btn-lg w-100">送信する</button>
                      </div>
                      <hr className="horizontal dark mb-3" />
                      <div className="text-center mb-3">
                        <Link className="btn btn-outline-secondary w-100" to={`/sign_in`}>
                          戻る
                        </Link>
                      </div>
                    </form>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </main>
    </SessionLayout>
  );
};
